var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 19,
    viewBox: "0 0 22 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00001 18.1C5.60001 18.1 3.10001 17.5 1.10001 16.4C0.700007 16.2 0.500007 15.8 0.600007 15.3C0.700007 14.9 1.00001 14.5 1.50001 14.5C3.20001 14.3 4.50001 14 5.70001 13.4C2.80001 11.2 1.30001 7.2 1.50001 2C1.50001 1.6 1.80001 1.2 2.10001 1.1C2.50001 0.9 2.90001 1 3.20001 1.3C5.20001 3.3 7.60001 5.4 9.90001 5.2C9.90001 4.2 10 2.6 10.9 1.5C11.7 0.5 12.9 0 14.4 0C16.1 0 17.2 1.1 17.8 1.8L20.1 1C20.5 0.9 21 1 21.2 1.3C21.5 1.6 21.5 2.1 21.2 2.5L19.4 5.2C19.6 6.4 19.8 10 17.1 13.6C14.9 16.8 11.4 18.1 8.00001 18.1ZM5.10001 15.7C8.90001 16.6 13.1 15.9 15.7 12.4C18.4 8.9 17.6 5.4 17.5 5.2C17.4 4.9 17.5 4.6 17.6 4.4L18 3.8L17.8 3.9C17.3 4.1 16.8 3.8 16.6 3.4C16.6 3.4 15.8 2 14.5 2C13.6 2 12.9 2.2 12.5 2.8C11.8 3.7 11.9 5.3 12 5.9C12.1 6.4 11.8 6.9 11.3 7C8.40001 8 5.50001 6.1 3.50001 4.4C3.80001 7.6 4.80001 11 8.00001 12.6C8.30001 12.8 8.50001 13.1 8.50001 13.4C8.50001 13.8 8.30001 14.1 8.00001 14.3C7.10001 14.9 6.10001 15.4 5.10001 15.7Z",
    fill: "#6F767E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.8c6ecc11b64c9c769ee711cc6c0f5f11.svg";
export { ForwardRef as ReactComponent };